(() => {
  'use strict';
  const config = JSON.parse(document.querySelector('[data-bae-commerce-data]')?.textContent || '{}');
  const copy = config.copy || {};
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = cents => new Intl.NumberFormat(config.locale || 'es', {style:'currency',currency:config.currency || 'EUR'}).format(Number(cents)/100);
  const track = (name, detail) => window.baeTrack?.(name, detail);
  let adding = false;
  async function add(items, status) {
    if (adding) return;
    adding = true;
    const controls = [...document.querySelectorAll('[data-bae-product] button, [data-bae-product] input, [data-bae-studio] button, [data-bae-studio] input')].map(element => ({element,disabled:element.disabled}));
    controls.forEach(({element}) => { element.disabled = true; });
    status.textContent = copy.adding;
    try {
      const response = await fetch(config.routes.add + '.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),credentials:'same-origin'});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || copy.cart_error);
      track('bae_add_to_cart',{items:items.map(item => ({id:item.id,quantity:item.quantity}))});
      location.assign(config.routes.cart);
    } catch (error) {
      status.replaceChildren(document.createTextNode((error.message || copy.cart_error) + ' ' + copy.cart_retry + ' '));
      const link = document.createElement('a');
      link.className = 'bae-link'; link.href = config.routes.cart; link.textContent = copy.view_cart;
      status.append(link);
      controls.forEach(({element,disabled}) => { element.disabled = disabled; });
      adding = false;
    }
  }
  function sizeGuide(product, scope) {
    const geometry = product.geometry;
    const heights = geometry?.rows?.find(row => /altura.*ciclista/i.test(row.label));
    if (!geometry?.cols?.length || !geometry?.rows?.length) return '';
    const table = '<div class="bae-geo-wrap"><table class="bae-geo"><thead><tr><th scope="col">' + escape(copy.measure) + '</th>' + geometry.cols.map(col => '<th scope="col">' + escape(col) + '</th>').join('') + '</tr></thead><tbody>' + geometry.rows.map(row => '<tr><th scope="row">' + escape(row.label) + (row.unit ? ' (' + escape(row.unit) + ')' : '') + '</th>' + row.values.map(value => '<td>' + escape(value) + '</td>').join('') + '</tr>').join('') + '</tbody></table></div>';
    const input = heights ? '<form data-height-form data-guide-product="' + product.id + '" class="bae-height-form"><label for="bae-height-' + scope + '">' + escape(copy.height) + '<input class="bae-input" id="bae-height-' + scope + '" type="number" inputmode="decimal" min="140" max="215" step="0.1" required name="height" placeholder="178"></label><button class="bae-btn bae-btn--secondary" type="submit">' + escape(copy.size_calculate) + '</button><div data-height-result class="bae-small" role="status"></div></form>' : '';
    return '<details class="bae-size-guide"><summary>' + escape(copy.size_guide) + '</summary><p class="bae-small">' + escape(copy.size_note) + '</p>' + input + table + '</details>';
  }
  function recommend(product, height) {
    const geometry = product.geometry;
    const row = geometry?.rows?.find(item => /altura.*ciclista/i.test(item.label));
    if (!row || !Number.isFinite(height)) return [];
    return row.values.flatMap((range,index) => {
      const bounds = String(range).replace(/,/g,'.').match(/\d+(?:\.\d+)?/g)?.map(Number);
      return bounds?.length === 2 && height >= bounds[0] && height <= bounds[1] ? [String(geometry.cols[index]).split(/[ ·]/)[0]] : [];
    });
  }
  function handleHeight(form, product) {
    const result = form.querySelector('[data-height-result]');
    const height = Number(form.elements.height.value);
    const sizes = recommend(product,height);
    result.replaceChildren(document.createTextNode(sizes.length ? copy.size_result + ' ' + sizes.join(' / ') + '. ' + copy.size_note : copy.size_outside));
    for (const size of sizes) {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'bae-chip'; button.dataset.applySize = size;
      button.dataset.productId = product.id; button.textContent = copy.size_apply + ' ' + size;
      const index = product.options.indexOf('Talla');
      button.disabled = !product.variants.some(variant => variant.available && variant.options[index] === size);
      result.append(button);
    }
  }
  window.BaeCommerce = {copy, escape, money, add, track, sizeGuide, recommend, handleHeight, routes:config.routes};
  for (const root of document.querySelectorAll('[data-bae-product]')) {
    const product = JSON.parse(root.querySelector('[data-commerce-product-data]').textContent);
    const variantInput = root.querySelector('[data-commerce-variant]');
    const pickers = [...root.querySelectorAll('[data-commerce-option]')];
    const sizeIndex = product.options.indexOf('Talla');
    const preselected = root.dataset.preselected;
    let sizeChosen = sizeIndex < 0 || !!preselected;
    let variant = product.variants.find(item => String(item.id) === preselected) || product.variants.find(item => item.available) || product.variants[0];
    if (preselected) pickers.forEach(input => { input.checked = variant.options[Number(input.dataset.commerceOption)] === input.value; });
    const guide = root.querySelector('[data-commerce-guide]');
    if (guide) guide.innerHTML = sizeGuide(product,'product-' + product.id);
    const status = root.querySelector('[data-commerce-status]');
    function update() {
      const options = product.options.map((name,index) => root.querySelector('[data-commerce-option="' + index + '"]:checked')?.value);
      variant = product.variants.find(item => item.options.every((value,index) => !options[index] || value === options[index]));
      variantInput.disabled = !variant || !sizeChosen || !variant.available;
      variantInput.value = variant?.id || '';
      root.querySelector('[data-commerce-price]').textContent = money(variant?.price ?? product.variants[0].price);
      root.querySelector('[data-commerce-availability]').textContent = !sizeChosen ? copy.choose_size : variant?.available ? copy.available : copy.sold_out;
      const addButton = root.querySelector('[data-commerce-add]');
      addButton.disabled = !sizeChosen || !variant?.available;
      addButton.textContent = !sizeChosen ? copy.choose_size : variant?.available ? (addButton.dataset.frameOnly === 'true' ? copy.add_frame : copy.add_product) : copy.sold_out;
      const configuration = root.querySelector('[data-commerce-build]');
      if (configuration) configuration.href = config.routes.root + 'pages/configurador?cuadro=' + encodeURIComponent(product.handle) + '&paso=ruedas' + (sizeChosen && variant ? '#f=' + variant.id + '&t=1' : '');
      pickers.forEach(input => {
        const index = Number(input.dataset.commerceOption);
        input.disabled = !product.variants.some(item => item.available && item.options[index] === input.value && item.options.every((value,i) => i === index || !options[i] || value === options[i]));
      });
      const image = root.querySelector('[data-commerce-image]');
      if (image && variant?.layer) { image.removeAttribute('srcset'); image.src = variant.layer; }
      if (sizeChosen && variant) {
        const url = new URL(location.href); url.searchParams.set('variant',variant.id);
        history.replaceState(null,'',url);
      }
    }
    root.addEventListener('change',event => {
      const input = event.target.closest('[data-commerce-option]');
      if (!input) return;
      if (Number(input.dataset.commerceOption) === sizeIndex) sizeChosen = true;
      status.textContent = ''; update();
      if (product.options[Number(input.dataset.commerceOption)] === 'Color') root.querySelector('[data-frame-gallery]')?.dispatchEvent(new CustomEvent('bae:color',{detail:input.value}));
      track(Number(input.dataset.commerceOption) === sizeIndex ? 'bae_size_selected' : 'bae_color_selected',{product:product.handle,variant:variant?.id});
    });
    root.addEventListener('submit',event => {
      if (event.target.matches('[data-height-form]')) { event.preventDefault(); handleHeight(event.target,product); return; }
      if (!event.target.matches('[data-commerce-form]')) return;
      event.preventDefault();
      if (!sizeChosen || !variant?.available) { status.textContent = copy.choose_size; return; }
      add([{id:variant.id,quantity:1}],status);
    });
    root.addEventListener('click',event => {
      const button = event.target.closest('[data-apply-size]');
      if (!button) return;
      const input = pickers.find(item => Number(item.dataset.commerceOption) === sizeIndex && item.value === button.dataset.applySize);
      if (input && !input.disabled) { input.checked = true; sizeChosen = true; update(); track('bae_size_selected',{product:product.handle,variant:variant?.id,source:'guide'}); }
    });
    update();
  }
  for (const root of document.querySelectorAll('[data-bae-size-page]')) {
    const product = JSON.parse(root.querySelector('[data-size-product]').textContent);
    const guide = root.querySelector('[data-size-page-guide]');
    guide.innerHTML = sizeGuide(product,'page-' + product.id);
    const details = guide.querySelector('details'); if (details) details.open = true;
    root.addEventListener('submit',event => { if (event.target.matches('[data-height-form]')) { event.preventDefault(); handleHeight(event.target,product); } });
    root.addEventListener('click',event => {
      const button = event.target.closest('[data-apply-size]'); if (!button) return;
      const index = product.options.indexOf('Talla');
      const variant = product.variants.find(item => item.available && item.options[index] === button.dataset.applySize);
      if (variant) location.assign(product.url + '?variant=' + variant.id);
    });
  }
})();

